module.exports = __webpack_public_path__ + "img/dianzi.b5f0ddd2.png";